export default "__VITE_ASSET__DOL7TQ8O__"